<template>
  <div class="warpper">
    <div class="nav">
      <div class='nav-logo'>
        <!-- <div class='nav-img'></div> -->
        <div class='nav-title'>{{navInfo.name}}</div>
      </div>
      <div class='menu'>
        <div :class="['menuItem',Index==index?'menuActive':'']" @click='addActive(index)' v-for="(item,index) in navInfo.navList" :key="index">
          <div class='menuIcon'>
            <img :src='item.src'>
          </div>
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="container">
      <back></back>
      <component 
        :is='switchItem' 
        :log='log' 
        :height='height' 
        :width='width'
        :oldWareId='oldWareId' 
        :macType='macType'
        :setTaskType='taskType'
        :nav='nav'>
      </component>
    </div>
  </div>
</template>

<script>
import wareConfig from '../system/wareConfig';
import foodType from '../system/foodType';
import oilType from '../system/oilType'
import dynamic from './dynamic'
import back from './back';
import userInfo from '../home/userInfo';
import editPassWord from '../home/editPassWord';
import flowCard from '../home/flowCard';
import notice from '../home/notice'
import feedback from '../home/feedBack';
import setMac from './setMac';
import setTask from './setTask';
import lineChart from './lineChart';
import management from './management';
import nitrogen from '../nitrogenAdjust/nitrogen'
import nitrTask from '../nitrogenAdjust/nitrTask'
export default {
  components:{
    back,
    dynamic,
    wareConfig,
    foodType,
    oilType,
    feedback,
    userInfo,
    editPassWord,
    notice,
    flowCard,
    setMac,
    setTask,
    lineChart,
    management,
    nitrogen,
    nitrTask
  },
  data(){
    return{
      height:0,
      width:0,
      Index:0,
      navInfo:{},
      switchItem:management,
      log:'',
      nav:'',
      oldWareId:'',
      macType:'',
      taskType:''
    }
  },
  created(){
    this.getSize()
    this.getNavInfo()
  },
  mounted(){
    window.onresize=()=>{
      this.getSize()
    }
  },
  methods:{
    getSize(){
      this.height=document.documentElement.clientHeight-50;
      this.width=document.documentElement.clientWidth-230;
    },
    getNavInfo(){
      let nav=this.$route.params.nav;
      this.nav=nav;
      switch(nav){
        case 'grain':
          this.navInfo={
            name:'粮情管理系统',
            navList:[
              {
                name:'粮温采集',
                src:require('../../assets/icon/temp.png'),
                item:'management',
                nav:'grain'
              },{
                name:'水分采集',
                src:require('../../assets/icon/water.png'),
                item:'management',
                nav:'water'
              },{
                name:'定时任务',
                src:require('../../assets/icon/setTime.png'),
                item:'setTask',
                taskType:'0'
              },{
                name:'设备管理',
                src:require('../../assets/icon/setMac.png'),
                item:'management',
                nav:'setMac'
              },{
                name:'设备维护',
                src:require('../../assets/icon/fixed.png'),
                item:'management',
                nav:'fixed'
              },{
                name:'单点曲线',
                src:require('../../assets/icon/pointLine.png'),
                item:'management',
                nav:'pointLine'
              },{
                name:'三温曲线',
                src:require('../../assets/icon/templine.png'),
                item:'lineChart',
                macType:'grain-2'
              },{
                name:'粮堆曲线',
                src:require('../../assets/icon/line.png'),
                item:'lineChart',
                macType:'grain-1'
              },{
                name:'粮温汇总',
                src:require('../../assets/icon/gather.png'),
                item:'management',
                nav:'gather'
              },{
                name:'水分汇总',
                src:require('../../assets/icon/waterGather.png'),
                item:'management',
                nav:'gatherWater'
              },{
                name:'日志管理',
                src:require('../../assets/icon/history.png'),
                item:'management',
                nav:'history'
              },{
                name:'粮温上传',
                src:require('../../assets/icon/feedback.png'),
                nav:'upTemp',
                item:'management'
              }
            ]
          };
          break;
        case 'oil':
          this.navInfo={
            name:'油情管理系统',
            navList:[{
              name:'油情信息',
              src:require('../../assets/icon/oilInfo.png'),
              item:'dynamic',
              nav:"oilWareInfo"
            },{
              name:'油罐配置',
              src:require('../../assets/icon/oilConfig.png'),
              item:'management',
              nav:'oilWareConfig'
            },{
              name:'设备管理',
              src:require('../../assets/icon/setMac.png'),
              item:'setMac',
              macType:'DEVYQSYS'
            },{
              name:'历史数据',
              src:require('../../assets/icon/history.png'),
              item:'management',
              nav:'oilHistory'
            }]
          };
          break;
        case 'circulation':
          this.navInfo={
            name:'环流控温系统',
            navList:[{
              name:'手动环流',
              src:require('../../assets/icon/cirHand.png'),
              item:'management',
              nav:'manualOperation'
            },{
              name:'定时任务',
              src:require('../../assets/icon/setTime.png'),
              item:'setTask',
              taskType:'3'
            },{
              name:'环流机配置',
              src:require('../../assets/icon/fanConfig.png'),
              item:'management',
              nav:'cirFanConfig'
            },{
              name:'控制器配置',
              src:require('../../assets/icon/setConfig.png'),
              item:'management',
              nav:'cirConfig'
            },{
              name:'设备管理',
              src:require('../../assets/icon/setMac.png'),
              item:'setMac',
              macType:'DEVNHLSYS',
            },
            // {
            //   name:'日志管理',
            //   src:require('../../assets/icon/history.png'),
            //   item:'management',
            //   nav:'cirHistory'
            // }
            ]
          };
          break;
        case 'air':
          this.navInfo={
            name:'空调控温系统',
            navList:[{
              name:'空调控温',
              src:require('../../assets/icon/airhand.png'),
              item:'dynamic',
              nav:'setTemp'
            },{
              name:'定时任务',
              src:require('../../assets/icon/setTime.png'),
              item:'setTask',
              taskType:'4'
            },{
              name:'空调配置',
              src:require('../../assets/icon/airConfig.png'),
              item:'dynamic',
              nav:'airConfig'
            },{
              name:'空调管理',
              src:require('../../assets/icon/airMac.png'),
              item:'setMac',
              macType:'DEVAIRCOND'
            },{
              name:'能耗曲线',
              src:require('../../assets/icon/pointLine.png'),
              item:'lineChart',
              macType:'DEVAIRCOND'
            },{
              name:'能耗汇总',
              src:require('../../assets/icon/history.png'),
              item:'management',
              nav:'airHistory'
            }]
          }
          break;
        case 'gasCheck':
          this.navInfo={
            name:'气体检测系统',
            navList:[{
              name:'气体浓度',
              src:require('../../assets/icon/gasTest.png'),
              item:'management',
              nav:'gasTest'
            },{
              name:'设备配置',
              src:require('../../assets/icon/setConfig.png'),
              item:'management',
              nav:'gasConfig'
            },{
              name:'设备管理',
              src:require('../../assets/icon/setMac.png'),
              item:'setMac',
              macType:'DEVGASSYS'
            },{
              name:'浓度曲线',
              src:require('../../assets/icon/gasLine.png'),
              item:'lineChart',
              macType:'DEVGASSYS'
            }]
          };
          break;
        case 'multifunctional':
          this.navInfo={
            name:'多功能系统',
            navList:[{
              name:'设备控制',
              src:require('../../assets/icon/control.png'),
              item:'dynamic',
              nav:'multifunctional'
            },{
              name:'设备管理',
              src:require('../../assets/icon/setMac.png'),
              item:'setMac',
              macType:'DEVWHZSK4G'
            }]
          };
          break;
        case 'nitrogen':
          this.navInfo={
            name:'气调管理系统',
            navList:[{
              name:'手动气调',
              item:'nitrogen'
            },{
              name:'气调任务',
              item:'nitrTask'
            },{
              name:'气密性检测'
            },{
              name:'气体浓度检测'
            },{
              name:'设备管理',
              src:require('../../assets/icon/setMac.png'),
              item:'setMac',
              macType:'DEVWHZSK4G'
            },{
              name:'气密性历史数据',
              src:require('../../assets/icon/history.png'),
              item:'management',
              nav:'gasHistory'
            },{
              name:'气体浓度历史数据',
              src:require('../../assets/icon/history.png'),
              item:'management',
              nav:'n2History'
            }]
          };
          break;
        case 'system':
          this.navInfo={
            name:'系统设置',
            navList:[{
              name:'仓房配置',
              src:require('../../assets/icon/ware.png'),
              item:'wareConfig'
            },{
              name:'粮食品种',
              src:require('../../assets/icon/food.png'),
              item:'foodType'
            },{
              name:'油脂品种',
              src:require('../../assets/icon/food.png'),
              item:'oilType'
            },{
              name:'修改密码',
              src:require('../../assets/icon/password.png'),
              item:'editPassWord'
            }]
          };
          break;
        default:
          this.navInfo={
            name:'管理中心',
            navList:[{
              name:'完善资料',
              src:require('../../assets/icon/edit.png'),
              item:'userInfo'
            },{
              name:'修改密码',
              src:require('../../assets/icon/password.png'),
              item:'editPassWord'
            },{
              name:'流量管理',
              src:require('../../assets/icon/flow.png'),
              item:'flowCard'
            },{
              name:'消息通知',
              src:require('../../assets/icon/message.png'),
              item:'notice'
            },{
              name:'意见反馈',
              src:require('../../assets/icon/feedback.png'),
              item:'feedback'
            }]
          };
      }
      this.addActive('')
    },
    addActive(num){
      let waterInfo=JSON.parse(localStorage.getItem('waterInfo'));
      if(num!==this.Index){
        if(num==''){
          if(waterInfo){
            this.Index=1;
            this.log=this.navInfo.navList[1].nav;
            this.switchItem=this.navInfo.navList[1].item;
            this.macType=this.navInfo.navList[1].macType;
            this.taskType=this.navInfo.navList[1].taskType;
          }else{
            this.Index=0;
            this.log=this.navInfo.navList[0].nav;
            this.switchItem=this.navInfo.navList[0].item;
            this.macType=this.navInfo.navList[0].macType;
            this.taskType=this.navInfo.navList[0].taskType;
          }
        }else{
          this.Index=num;
          this.log=this.navInfo.navList[num].nav;
          this.switchItem=this.navInfo.navList[num].item;
          this.macType=this.navInfo.navList[num].macType;
          this.taskType=this.navInfo.navList[num].taskType;
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.warpper{
  height: 100%;
  width: 100%;
  position: relative;
  .nav{
    height: 100%;
    width: 230px;
    background: linear-gradient(143deg,#396FE8 0%,#477CFF 100%);
    box-shadow: 5px 4px 15px 0 rgba(0,0,0,.04);
    .nav-logo{
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      .nav-title{
        font-size: 24px;
        font-weight: 400;
        font-family: 'pangmen';
        color: white;
        letter-spacing: 2px
      }
    }
  }
  .menu{
    padding-top: 4px;
    .menuItem{
      height: 56px;
      color: white;
      font-size: 14px;
      cursor: pointer;
      font-weight: 400;
      display: flex;
      align-items: center;
      .menuIcon{
        margin-right: 10px;
        margin-left: 45px;
        img{
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
      }
    }
    .menuActive{
      background-color: #5888F2
    }
  }
}
.container{
  position: absolute;
  top: 0;
  left: 230px;
  background: white;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>